(()=>{'use strict';
  if(window.__TDM_VIDEO_ENGINE__)return;
  window.__TDM_VIDEO_ENGINE__=true;

  const mounted=new Map();
  const registeredVideos=new Set();
  const reevaluators=new Set();
  let globalPlaying=null;
  const reduceMotion=()=>window.matchMedia?.('(prefers-reduced-motion: reduce)').matches===true;
  const connection=()=>navigator.connection||navigator.mozConnection||navigator.webkitConnection;
  const conserveData=()=>{
    const c=connection();
    return c?.saveData===true || /(^|-)2g$/.test(String(c?.effectiveType||''));
  };
  const canAutoPlay=()=>!reduceMotion()&&!conserveData()&&!document.hidden;
  const qs=(s,r=document)=>r.querySelector(s);
  const qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));
  const clamp=(n,min,max)=>Math.min(max,Math.max(min,n));

  function hydrate(video){
    if(!video||video.dataset.tdmHydrated==='true')return video;
    const poster=video.dataset.poster;if(poster){video.poster=poster;video.removeAttribute('data-poster')}
    const src=video.dataset.src;
    if(src){video.src=src;video.removeAttribute('data-src')}
    qsa('source[data-src]',video).forEach(source=>{
      source.src=source.dataset.src||'';
      source.removeAttribute('data-src');
    });
    video.dataset.tdmHydrated='true';
    video.preload='metadata';
    try{video.load()}catch{}
    return video;
  }

  function updateControls(video){
    const card=video?.closest?.('[data-tdm-video-card]');
    if(!card)return;
    const play=qs('[data-tdm-video-play]',card),sound=qs('[data-tdm-video-sound]',card);
    const playing=!video.paused&&!video.ended;
    card.classList.toggle('is-video-paused',!playing);
    card.classList.toggle('is-video-playing',playing);
    if(play){
      play.setAttribute('aria-pressed',playing?'true':'false');
      play.setAttribute('aria-label',playing?'Pausar video':'Reproducir video');
      play.classList.toggle('is-playing',playing);
    }
    if(sound){
      const on=!video.muted&&video.volume>0;
      sound.setAttribute('aria-pressed',on?'true':'false');
      sound.setAttribute('aria-label',on?'Silenciar video':'Activar sonido');
      sound.classList.toggle('is-audible',on);
    }
  }

  function pause(video,{resetSound=false}={}){
    if(!video)return;
    try{video.pause()}catch{}
    if(resetSound)video.muted=true;
    if(globalPlaying===video)globalPlaying=null;
    updateControls(video);
  }

  function pauseOthers(except,{mute=true}={}){
    registeredVideos.forEach(video=>{
      if(video===except)return;
      if(mute)video.muted=true;
      if(!video.paused)pause(video);
      else updateControls(video);
    });
  }

  async function play(video,{audible=false,user=false}={}){
    if(!video)return false;
    if(globalPlaying===video&&!video.paused&&!video.ended){if(audible)video.muted=false;updateControls(video);return true}
    hydrate(video);
    pauseOthers(video,{mute:true});
    if(audible)video.muted=false;
    else if(!user)video.muted=true;
    try{
      const result=video.play();
      if(result?.then)await result;
      globalPlaying=video;
      updateControls(video);
      return true;
    }catch{
      video.muted=true;
      updateControls(video);
      return false;
    }
  }

  function registerVideo(video,signal){
    if(!video||registeredVideos.has(video))return;
    registeredVideos.add(video);
    video.muted=video.hasAttribute('muted')||video.muted;
    const sync=()=>updateControls(video);
    ['play','pause','ended','volumechange'].forEach(type=>video.addEventListener(type,sync,{signal}));
    updateControls(video);
  }

  function unregisterVideo(video){
    if(!video)return;
    pause(video,{resetSound:true});
    registeredVideos.delete(video);
  }

  function money(cents,source){
    if(source?.variants){
      const v=source.variants.find(x=>Number(x.price)===Number(cents)&&x.priceMoney);
      if(v?.priceMoney)return v.priceMoney;
    }
    const currency=source?.currency||window.Shopify?.currency?.active||'ARS';
    try{return new Intl.NumberFormat(document.documentElement.lang||'es-AR',{style:'currency',currency,minimumFractionDigits:0,maximumFractionDigits:0}).format((Number(cents)||0)/100)}catch{return `$${Math.round((Number(cents)||0)/100).toLocaleString('es-AR')}`}
  }

  function syncCurrentProductOverlays(detail){
    const variant=detail?.variant,source=detail?.source;if(!variant)return;
    qsa('[data-tdm-ugc-current-product]').forEach(overlay=>{
      const imgWrap=qs('[data-tdm-ugc-product-image-wrap]',overlay),img=imgWrap?qs('img',imgWrap):null;
      if(img&&variant.image){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=variant.image}
      const price=qs('[data-tdm-ugc-price]',overlay);
      if(price)price.textContent=variant.priceMoney||money(variant.price,source);
      const compare=qs('[data-tdm-ugc-compare]',overlay);
      if(compare){
        const show=Number(variant.compareAtPrice)>Number(variant.price);
        compare.hidden=!show;
        if(show)compare.textContent=variant.compareMoney||money(variant.compareAtPrice,source);
      }
    });
  }

  function mountTrackSection(root,mode){
    const ac=new AbortController(),signal=ac.signal;
    const track=qs('[data-tdm-video-track]',root);
    if(!track)return()=>ac.abort();

    let originals=qsa('[data-tdm-video-card]:not([data-tdm-loop-clone])',track);
    originals.forEach((card,i)=>{if(card.dataset.tdmLogicalIndex==null)card.dataset.tdmLogicalIndex=String(i)});
    const loopEnabled=mode==='ugc-pdp'&&root.dataset.ugcLoop==='true'&&originals.length>=3;
    const cloneCount=loopEnabled?Math.min(2,originals.length):0;

    function makeLoopClone(source){
      const clone=source.cloneNode(true);
      clone.dataset.tdmLoopClone='true';
      clone.dataset.tdmLogicalIndex=source.dataset.tdmLogicalIndex||'0';
      clone.setAttribute('aria-hidden','true');
      clone.removeAttribute('data-shopify-editor-block');
      qsa('[data-shopify-editor-block]',clone).forEach(el=>el.removeAttribute('data-shopify-editor-block'));
      qsa('[id]',clone).forEach(el=>el.removeAttribute('id'));
      qsa('a,button,input,select,textarea,[tabindex]',clone).forEach(el=>el.setAttribute('tabindex','-1'));
      return clone;
    }

    if(loopEnabled&&!track.dataset.tdmLoopPrepared){
      const before=document.createDocumentFragment(),after=document.createDocumentFragment();
      originals.slice(-cloneCount).forEach(card=>before.appendChild(makeLoopClone(card)));
      originals.slice(0,cloneCount).forEach(card=>after.appendChild(makeLoopClone(card)));
      track.insertBefore(before,track.firstChild);
      track.appendChild(after);
      track.dataset.tdmLoopPrepared='true';
      root.dataset.tdmLoopReady='true';
    }

    const cards=()=>qsa('[data-tdm-video-card]',track);
    const realCards=()=>qsa('[data-tdm-video-card]:not([data-tdm-loop-clone])',track);
    originals=realCards();
    const logicalCount=Math.max(1,originals.length);
    const logicalOf=card=>clamp(Number(card?.dataset?.tdmLogicalIndex)||0,0,logicalCount-1);
    const originalForLogical=index=>originals[clamp(Number(index)||0,0,logicalCount-1)]||originals[0]||null;
    const centerLeft=card=>card?Math.max(0,card.offsetLeft-(track.clientWidth-card.offsetWidth)/2):0;
    const centerCard=(card,behavior='auto')=>{if(card)track.scrollTo({left:centerLeft(card),behavior})};

    cards().forEach(card=>{const v=qs('[data-tdm-video]',card);if(v)registerVideo(v,signal)});
    let activeCard=null,activeLogical=0,lastAnnouncedLogical=-1,sectionVisible=false,sectionNear=false,raf=0,manualPaused=new WeakSet(),normalizing=false,settleTimer=0;
    const controlTimers=new Map();
    const controlTimeout=clamp(Number(root.dataset.ugcControlTimeout)||1100,600,2000);
    function clearControlTimer(card){const id=controlTimers.get(card);if(id){clearTimeout(id);controlTimers.delete(card)}}
    function concealControls(card){if(!card)return;clearControlTimer(card);card.classList.remove('is-controls-visible')}
    function revealControls(card,{persistent=false}={}){
      if(!card)return;clearControlTimer(card);card.classList.add('is-controls-visible');
      const video=qs('[data-tdm-video]',card);if(persistent||!video||video.paused)return;
      const id=setTimeout(()=>{if(!video.paused)card.classList.remove('is-controls-visible');controlTimers.delete(card)},controlTimeout);controlTimers.set(card,id);
    }

    const nearObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      const e=entries[0];sectionNear=!!e&&e.isIntersecting;if(sectionNear)hydrateNeighborhood();
    },{rootMargin:'600px 0px',threshold:0}):null;
    const visibleObserver='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      const e=entries[0];sectionVisible=!!e&&e.isIntersecting&&e.intersectionRatio>=.12;
      if(sectionVisible)schedule();else cards().forEach(c=>pause(qs('[data-tdm-video]',c)));
    },{threshold:[0,.12,.35,.65]}):null;
    nearObserver?.observe(root);visibleObserver?.observe(root);
    if(!nearObserver){sectionNear=true}if(!visibleObserver){sectionVisible=true}

    const nearest=()=>{
      const list=cards();if(!list.length)return null;
      const tr=track.getBoundingClientRect(),center=tr.left+tr.width/2;
      let best=null,dist=Infinity;
      list.forEach(card=>{const r=card.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-center);if(d<dist){dist=d;best=card}});
      return best;
    };

    function hydrateNeighborhood(){
      if(!sectionNear||reduceMotion()||conserveData())return;
      const list=cards(),card=activeCard||nearest(),i=list.indexOf(card);
      [i-1,i,i+1].forEach(idx=>{const c=list[idx];if(c)hydrate(qs('[data-tdm-video]',c))});
    }

    function announceLogical(){
      if(activeLogical===lastAnnouncedLogical)return;
      lastAnnouncedLogical=activeLogical;
      root.dispatchEvent(new CustomEvent('tdm:ugc:change',{bubbles:true,detail:{index:activeLogical,count:logicalCount,loop:loopEnabled}}));
    }

    function continuousLogicalPosition(){
      if(logicalCount<=1)return 0;
      const list=cards();if(!list.length)return activeLogical;
      const viewportCenter=track.scrollLeft+track.clientWidth/2;
      const points=list.map(card=>({card,center:card.offsetLeft+card.offsetWidth/2,logical:logicalOf(card)}));
      if(viewportCenter<=points[0].center)return points[0].logical;
      for(let i=0;i<points.length-1;i++){
        const a=points[i],b=points[i+1];if(viewportCenter>b.center)continue;
        const span=Math.max(1,b.center-a.center),t=clamp((viewportCenter-a.center)/span,0,1);
        if(a.logical===logicalCount-1&&b.logical===0)return (logicalCount-1)*(1-t);
        return a.logical+(b.logical-a.logical)*t;
      }
      return points[points.length-1].logical;
    }

    function scrollToLogicalPosition(position){
      if(!originals.length)return;
      const pos=clamp(Number(position)||0,0,logicalCount-1),lo=Math.floor(pos),hi=Math.min(logicalCount-1,Math.ceil(pos)),t=pos-lo;
      const a=originalForLogical(lo),b=originalForLogical(hi);if(!a)return;
      const leftA=centerLeft(a),leftB=b?centerLeft(b):leftA;track.scrollLeft=leftA+(leftB-leftA)*t;
    }

    function updateProgress(){
      const progressTrack=qs('[data-tdm-video-progress-track]',root),thumb=qs('[data-tdm-video-progress-thumb]',root);
      if(!progressTrack||!thumb)return;
      if(loopEnabled){
        const width=Math.max(20,progressTrack.clientWidth/Math.max(1,logicalCount)),free=Math.max(0,progressTrack.clientWidth-width),position=continuousLogicalPosition();
        thumb.style.width=width+'px';
        thumb.style.left=(logicalCount>1?(position/(logicalCount-1))*free:0)+'px';
        const wrap=progressTrack.parentElement;if(wrap)wrap.hidden=logicalCount<=1;
        return;
      }
      const max=Math.max(0,track.scrollWidth-track.clientWidth),ratio=track.scrollWidth?Math.min(1,track.clientWidth/track.scrollWidth):1;
      const width=Math.max(20,progressTrack.clientWidth*ratio),free=Math.max(0,progressTrack.clientWidth-width);
      thumb.style.width=width+'px';
      thumb.style.left=(max>0?clamp(track.scrollLeft/max,0,1)*free:0)+'px';
      const wrap=progressTrack.parentElement;if(wrap)wrap.hidden=max<=1;
    }

    function evaluate(){
      raf=0;
      const next=nearest();
      if(!next)return;
      if(activeCard!==next){
        if(activeCard){
          concealControls(activeCard);
          activeCard.classList.remove('is-center','is-video-active');
          const old=qs('[data-tdm-video]',activeCard);pause(old);manualPaused.delete(old);
        }
        activeCard=next;
      }
      activeLogical=logicalOf(activeCard);
      cards().forEach(c=>{
        const on=c===activeCard;
        c.classList.toggle('is-center',on);
        c.classList.toggle('is-video-active',on);
        c.setAttribute('data-video-active',on?'true':'false');
      });
      qsa('[data-tdm-video-dot]',root).forEach((dot,i)=>dot.setAttribute('aria-current',i===activeLogical?'true':'false'));
      const progressA11y=qs('[data-tdm-video-progress-track]',root);if(progressA11y){progressA11y.setAttribute('aria-valuemax',String(logicalCount));progressA11y.setAttribute('aria-valuenow',String(activeLogical+1))}
      root.dataset.ugcActiveIndex=String(activeLogical);
      announceLogical();hydrateNeighborhood();updateProgress();
      const video=qs('[data-tdm-video]',activeCard);
      if(!video)return;
      if(sectionVisible&&canAutoPlay()&&!manualPaused.has(video))play(video,{audible:false,user:false});
      else if(!sectionVisible||!canAutoPlay())pause(video);
    }
    const schedule=()=>{if(raf)return;raf=requestAnimationFrame(evaluate)};

    function normalizeLoop(){
      if(!loopEnabled||normalizing)return;
      const card=nearest();if(!card?.hasAttribute('data-tdm-loop-clone'))return;
      const logical=logicalOf(card),target=originalForLogical(logical);if(!target)return;
      const cloneVideo=qs('[data-tdm-video]',card),wasPlaying=!!cloneVideo&&!cloneVideo.paused,wasMuted=cloneVideo?.muted!==false;
      const resumeTime=cloneVideo?.currentTime||0;
      normalizing=true;
      if(cloneVideo)pause(cloneVideo);
      centerCard(target,'auto');
      activeCard=target;activeLogical=logical;
      requestAnimationFrame(()=>{
        normalizing=false;evaluate();
        const targetVideo=qs('[data-tdm-video]',target);
        if(root.dataset.ugcPremium==='true'&&targetVideo){
          const restore=()=>{try{targetVideo.currentTime=resumeTime}catch{}};
          if(targetVideo.readyState>=1)restore();else targetVideo.addEventListener('loadedmetadata',restore,{once:true,signal});
        }
        if(wasPlaying&&targetVideo&&sectionVisible&&canAutoPlay()&&!manualPaused.has(targetVideo))play(targetVideo,{audible:!wasMuted,user:false});
      });
    }
    const queueNormalize=()=>{if(!loopEnabled)return;clearTimeout(settleTimer);settleTimer=setTimeout(normalizeLoop,110)};

    track.addEventListener('scroll',()=>{schedule();updateProgress();queueNormalize()},{passive:true,signal});
    if('onscrollend' in track)track.addEventListener('scrollend',normalizeLoop,{passive:true,signal});
    let lastTrackWidth=track.clientWidth;
    const ro='ResizeObserver' in window?new ResizeObserver(()=>{if(root.dataset.ugcPremium==='true'&&track.clientWidth!==lastTrackWidth){lastTrackWidth=track.clientWidth;centerCard(originalForLogical(activeLogical),'auto')}schedule();updateProgress()}):null;ro?.observe(track);

    function physicalNeighbor(direction){
      const list=cards(),current=activeCard||nearest(),i=Math.max(0,list.indexOf(current));
      return list[clamp(i+direction,0,list.length-1)]||current;
    }
    const prev=qs('[data-tdm-video-prev]',root),next=qs('[data-tdm-video-next]',root);
    const goDirection=direction=>{
      if(loopEnabled){centerCard(physicalNeighbor(direction),reduceMotion()?'auto':'smooth');return}
      const list=cards(),current=activeCard||nearest(),i=Math.max(0,list.indexOf(current)),target=list[clamp(i+direction,0,list.length-1)];
      centerCard(target,reduceMotion()?'auto':'smooth');
    };
    prev?.addEventListener('click',()=>goDirection(-1),{signal});
    next?.addEventListener('click',()=>goDirection(1),{signal});

    qsa('[data-tdm-video-dot]',root).forEach(dot=>dot.addEventListener('click',()=>{
      const card=originalForLogical(Math.max(0,Number(dot.dataset.tdmVideoDot)||0));
      centerCard(card,reduceMotion()?'auto':'smooth');
    },{signal}));

    const progressRail=qs('[data-tdm-video-progress-track]',root);
    progressRail?.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();
      let target=activeLogical;
      if(e.key==='ArrowLeft')target=loopEnabled?(activeLogical-1+logicalCount)%logicalCount:Math.max(0,activeLogical-1);
      if(e.key==='ArrowRight')target=loopEnabled?(activeLogical+1)%logicalCount:Math.min(logicalCount-1,activeLogical+1);
      if(e.key==='Home')target=0;if(e.key==='End')target=Math.max(0,logicalCount-1);
      centerCard(originalForLogical(target),reduceMotion()?'auto':'smooth');
    },{signal});
    progressRail?.addEventListener('click',e=>{
      if(e.target.closest?.('[data-tdm-video-progress-thumb]'))return;
      const r=progressRail.getBoundingClientRect(),ratio=clamp((e.clientX-r.left)/Math.max(1,r.width),0,1);
      if(loopEnabled){centerCard(originalForLogical(Math.round(ratio*(logicalCount-1))),reduceMotion()?'auto':'smooth');return}
      const max=Math.max(0,track.scrollWidth-track.clientWidth);track.scrollTo({left:ratio*max,behavior:reduceMotion()?'auto':'smooth'});
    },{signal});

    root.addEventListener('click',e=>{
      const shop=e.target.closest?.('[data-tdm-video-shop]');
      if(shop&&root.contains(shop)){
        if(shop.dataset.tdmCurrentProduct==='true'){
          const buy=document.querySelector('.tdh-sm-packs [data-sm-pk], .tdh-sm-info [data-tdm-info], [data-tdm-buy]');
          if(buy){e.preventDefault();buy.scrollIntoView({behavior:reduceMotion()?'auto':'smooth',block:'center'});setTimeout(()=>buy.querySelector?.('button,input,select,[tabindex]:not([tabindex="-1"])')?.focus?.({preventScroll:true}),reduceMotion()?0:350)}
        }
        return;
      }
      const card=e.target.closest?.('[data-tdm-video-card]');if(!card||!root.contains(card))return;
      const video=qs('[data-tdm-video]',card);if(!video)return;
      const playButton=e.target.closest?.('[data-tdm-video-play]');
      const soundButton=e.target.closest?.('[data-tdm-video-sound]');
      if(mode==='ugc-pdp'&&card!==activeCard&&!card.classList.contains('is-center')){
        e.preventDefault();centerCard(card,reduceMotion()?'auto':'smooth');return;
      }
      if(playButton){
        e.preventDefault();activeCard=card;activeLogical=logicalOf(card);
        if(!video.paused){manualPaused.add(video);pause(video);revealControls(card,{persistent:true})}
        else{manualPaused.delete(video);play(video,{audible:!video.muted,user:true});revealControls(card)}
        return;
      }
      if(soundButton){
        e.preventDefault();activeCard=card;activeLogical=logicalOf(card);
        hydrate(video);
        const makeAudible=video.muted||video.volume===0;
        video.muted=!makeAudible;
        updateControls(video);
        return;
      }
      if(video.hasAttribute('data-tdm-click-toggle')&&e.target===video){
        activeCard=card;activeLogical=logicalOf(card);
        if(!video.paused){revealControls(card)}
        else{manualPaused.delete(video);play(video,{audible:!video.muted,user:true});revealControls(card)}
      }
    },{signal});

    root.addEventListener('keydown',e=>{
      const video=e.target.closest?.('[data-tdm-video][data-tdm-click-toggle]');if(!video||!root.contains(video))return;
      if(e.key!=='Enter'&&e.key!==' ')return;e.preventDefault();
      const card=video.closest('[data-tdm-video-card]');
      if(mode==='ugc-pdp'&&card!==activeCard&&!card.classList.contains('is-center')){centerCard(card,reduceMotion()?'auto':'smooth');return}
      activeCard=card;activeLogical=logicalOf(card);
      if(!video.paused){manualPaused.add(video);pause(video);revealControls(card,{persistent:true})}
      else{manualPaused.delete(video);play(video,{audible:!video.muted,user:true});revealControls(card)}
    },{signal});

    if(root.dataset.ugcPremium==='true'){
      let pointer=null,suppressClick=false;
      track.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,a'))return;
        pointer={id:e.pointerId,x:e.clientX,left:track.scrollLeft,moved:false};
      },{signal});
      track.addEventListener('pointermove',e=>{
        if(!pointer||e.pointerId!==pointer.id)return;
        const dx=e.clientX-pointer.x;
        if(!pointer.moved&&Math.abs(dx)<7)return;
        pointer.moved=true;track.classList.add('is-dragging');track.setPointerCapture(e.pointerId);
        track.scrollLeft=pointer.left-dx;e.preventDefault();
      },{signal});
      const endPointer=e=>{
        if(!pointer||e.pointerId!==pointer.id)return;
        const moved=pointer.moved;pointer=null;track.classList.remove('is-dragging');
        if(track.hasPointerCapture(e.pointerId))track.releasePointerCapture(e.pointerId);
        if(moved){suppressClick=true;centerCard(nearest(),reduceMotion()?'auto':'smooth');setTimeout(()=>{suppressClick=false},0)}
      };
      track.addEventListener('pointerup',endPointer,{signal});track.addEventListener('pointercancel',endPointer,{signal});
      track.addEventListener('click',e=>{if(suppressClick){e.preventDefault();e.stopImmediatePropagation()}},{capture:true,signal});
      track.addEventListener('keydown',e=>{
        if(!['ArrowLeft','ArrowRight'].includes(e.key))return;
        e.preventDefault();goDirection(e.key==='ArrowLeft'?-1:1);
      },{signal});
    }

    let drag=null;
    const progressThumb=qs('[data-tdm-video-progress-thumb]',root),progressTrack=qs('[data-tdm-video-progress-track]',root);
    progressThumb?.addEventListener('pointerdown',e=>{
      const free=Math.max(0,(progressTrack?.clientWidth||0)-(progressThumb?.clientWidth||0));if(free<=0)return;
      drag={id:e.pointerId,startX:e.clientX,startLeft:progressThumb.offsetLeft||0};progressThumb.setPointerCapture?.(e.pointerId);e.preventDefault();
    },{signal});
    progressThumb?.addEventListener('pointermove',e=>{
      if(!drag||drag.id!==e.pointerId)return;
      const free=Math.max(0,progressTrack.clientWidth-progressThumb.clientWidth);if(free<=0)return;
      const x=clamp(drag.startLeft+e.clientX-drag.startX,0,free);progressThumb.style.left=x+'px';
      if(loopEnabled){const ratio=x/free;scrollToLogicalPosition(ratio*(logicalCount-1));return}
      const max=Math.max(0,track.scrollWidth-track.clientWidth);if(max>0)track.scrollLeft=(x/free)*max;
    },{signal});
    const stopDrag=e=>{if(!drag||e.pointerId!==drag.id)return;drag=null};
    progressThumb?.addEventListener('pointerup',stopDrag,{signal});progressThumb?.addEventListener('pointercancel',stopDrag,{signal});

    function initializePosition(){
      const start=root.dataset.ugcStart==='center'?Math.floor(originals.length/2):0;
      const target=originalForLogical(start);if(!target)return;
      centerCard(target,'auto');activeCard=target;activeLogical=start;evaluate();updateProgress();hydrateNeighborhood();
    }

    reevaluators.add(schedule);
    requestAnimationFrame(()=>requestAnimationFrame(initializePosition));
    return()=>{
      if(raf)cancelAnimationFrame(raf);clearTimeout(settleTimer);controlTimers.forEach(id=>clearTimeout(id));controlTimers.clear();reevaluators.delete(schedule);nearObserver?.disconnect();visibleObserver?.disconnect();ro?.disconnect();
      cards().forEach(c=>{concealControls(c);unregisterVideo(qs('[data-tdm-video]',c))});qsa('[data-tdm-loop-clone]',track).forEach(c=>c.remove());delete track.dataset.tdmLoopPrepared;delete root.dataset.tdmLoopReady;ac.abort();
    };
  }

  function mountGallery(root){
    const ac=new AbortController(),signal=ac.signal;
    const videos=qsa('[data-tdm-video]',root);if(!videos.length)return()=>ac.abort();
    videos.forEach(v=>registerVideo(v,signal));
    const ratios=new Map(videos.map(v=>[v,0]));
    const evaluate=()=>{
      const best=[...ratios].sort((a,b)=>b[1]-a[1])[0];
      videos.forEach(v=>{if(!best||v!==best[0]||best[1]<.55||!canAutoPlay())pause(v)});
      if(best&&best[1]>=.55&&canAutoPlay())play(best[0],{audible:false,user:false});
    };
    const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
      entries.forEach(e=>ratios.set(e.target,e.isIntersecting?e.intersectionRatio:0));evaluate();
    },{rootMargin:'180px 0px',threshold:[0,.25,.55,.8]}):null;
    if(observer)videos.forEach(v=>observer.observe(v));
    reevaluators.add(evaluate);
    return()=>{reevaluators.delete(evaluate);observer?.disconnect();videos.forEach(unregisterVideo);ac.abort()};
  }

  function mountRoot(root){
    if(!root||mounted.has(root))return;
    const mode=root.dataset.videoMode||'';
    const cleanup=mode==='gallery'?mountGallery(root):mountTrackSection(root,mode);
    mounted.set(root,cleanup);
  }
  function init(scope=document){
    if(scope.matches?.('[data-tdm-video-section]'))mountRoot(scope);
    qsa('[data-tdm-video-section]',scope).forEach(mountRoot);
  }
  function unmount(scope){
    for(const [root,cleanup] of [...mounted]){
      if(root===scope||scope?.contains?.(root)){
        try{cleanup?.()}catch(e){console.warn('[TDM video cleanup]',e)}
        mounted.delete(root);
      }
    }
  }
  function pauseAll(){registeredVideos.forEach(v=>pause(v))}
  function reevaluate(){reevaluators.forEach(fn=>{try{fn()}catch(e){console.warn('[TDM video reevaluate]',e)}})}

  document.addEventListener('tdm:variant:change',e=>syncCurrentProductOverlays(e.detail));
  document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseAll();else reevaluate()});
  window.addEventListener('pagehide',pauseAll);
  window.addEventListener('pageshow',()=>requestAnimationFrame(reevaluate));
  window.matchMedia?.('(prefers-reduced-motion: reduce)').addEventListener?.('change',()=>{pauseAll();reevaluate()});
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>unmount(e.target));
  init(document);

  window.TdmVideoEngine={hydrate,play,pause,pauseAll,init,unmount};
})();

